<div class="row h-100">
  <div class="col-12 d-flex flex-column align-items-stretch">
    <div class="row fields-group mb-3 flex-shrink-1">
      <div class="col-md-12">
        <label class="input-label field-required">{{ 'Name' | translate }}
        </label>
        <input class="form-control" type="text" name="subject" [(ngModel)]="currentMessage.subject" placeholder="{{
              'annexes.messages.english_name_placeholder' | translate
            }}" #msgSubject="ngModel" [rangeLength]="[2, 256]" required autofocus />
        <p class="validation-error" *ngIf="msgSubject?.errors?.required && (msgSubject?.dirty && msgSubject?.touched)">
          {{ 'form.validate.required' | translate }}
        </p>
        <p class="validation-error"
          *ngIf="msgSubject?.errors?.rangeLength && (msgSubject?.dirty && msgSubject?.touched)">
          {{ 'form.validate.minLenght' | translate }} 2!
        </p>
        <p class="validation-error"
          *ngIf="msgSubject?.errors?.rangeLength && (msgSubject?.dirty && msgSubject?.touched)">
          {{ 'form.validate.maxLenght' | translate }} 256!
        </p>
      </div>
    </div>
    <div class="row fields-group flex-grow-1">
      <div class="col d-flex flex-column">
        <div class="row fields-group-header flex-shrink-1">
          <div class="col-md-4 d-flex justify-content-start align-items-center">
            <label class="input-label field-required mb-0">
              {{ 'annexes.messages.body' | translate }}
              <i class="fal fa-lightbulb ml-2 mr-1"
                [tooltip]="'You could use mustache template syntax in the content of the message' | translate"
                aria-hidden="true"></i>
            </label>
          </div>
          <div class="col-md-4 d-flex justify-content-center py-1">
            <div class="btn-group-primary-light btn-group-toggles btn-group-toggles-small d-inline-flex">
              <button *ngFor="let option of availableChannels" (click)="updateChannel(option.id)"
                  class="btn-group-toggle {{option.id === currentMessage.channel ? 'active' : ''}}" [ngClass]="{'disabled': option.disabled}">
                  <i *ngIf="option.icon" class="far fa-{{option.icon}} mr-1"></i>{{ option.name | translate }}
              </button>
            </div>
          </div>
          <div class="col-md-4 d-flex justify-content-end">
            <toggle-switch [containerClass]="'toggle-switch-field'"
              [tooltip]="'Show/hide moustaches helper' | translate" placement="left" [toggled]="moustachHelper"
              (toggledChange)="moustachHelper = $event" [label]="'Moustaches' | translate"></toggle-switch>
          </div>
        </div>
        <div class="row fields-group-content flex-grow-1">
          <div class="d-flex flex-column {{ moustachHelper ? 'col-md-8 pr-4' : 'col-md-12'}}">
            <label class="input-label mb-2 d-flex justify-content-between align-items-center">
              {{ 'Composer' | translate }}
              <small class="mb-0 badge badge-{{isSmsLimitExceeded ? 'danger' : 'default'}}"
                *ngIf="currentMessage.channel === 'SMS' || currentMessage.channel === 'WHATSAPP'">
                {{ messageLength }}
                <span *ngIf="currentMessage.channel === 'SMS'"> / {{ smsLimit }}</span>
              </small>
            </label>
            <ng-container *ngIf="currentMessage.channel === 'EMAIL'; else plainTextEditor">
              <ckeditor class="message-editor" [editor]="Editor" [config]="config" [(ngModel)]="currentMessage.content">
              </ckeditor>
            </ng-container>
            <ng-template #plainTextEditor>
              <textarea class="form-control content-editor" rows="10" style="height: 100%;"
                [(ngModel)]="currentMessage.content" name="messageContent"></textarea>
            </ng-template>
          </div>
          <div class="d-flex flex-column fields-group-toggle-part {{ moustachHelper ? 'col-md-4 pl-4' : 'hidden'}}">
            <label class="input-label mb-2">
              {{ 'Moustaches' | translate }}
              <i class="fal fa-lightbulb ml-2 mr-1" [tooltip]="'Select fields to get data from' | translate"
                aria-hidden="true"></i>
            </label>
            <sfl *ngIf="moustachHelper" [serviceId]="serviceId"></sfl>
          </div>
        </div>
      </div>
    </div>
    <div class="row mb-3 flex-shrink-1">
      <div class="col-md-12">
        <p class="validation-error" *ngIf="msgBody?.errors?.required && (msgBody?.dirty && msgBody?.touched)">
          {{ 'form.validate.required' | translate }}
        </p>
      </div>
    </div>
    <div class="row fields-group mb-3 flex-shrink-1" *ngIf='currentMessage.id'>
      <div class="col-md-12">
        <label class="input-label">{{ 'annexes.messages.used_in_registration' | translate }}
        </label>
        <ng-select [(ngModel)]="statusRegistrationIds" name="usedInRegistrations" bindLabel="text" bindValue="id"
          [readonly]="true" [multiple]="true" [items]="statusRegistrations"></ng-select>
      </div>
    </div>
  </div>
</div>